module.exports = __webpack_public_path__ + "img/pay.e1dd783c.png";